var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0787 5.66663L13.1709 3.71372L11.1573 2.83331L13.1709 1.95291L14.0787 0L14.9864 1.95291L17 2.83331L14.9864 3.71372L14.0787 5.66663ZM14.0787 17L13.1709 15.0471L11.1573 14.1667L13.1709 13.2863L14.0787 11.3334L14.9864 13.2863L17 14.1667L14.9864 15.0471L14.0787 17ZM5.82618 14.1506L4.01066 10.2608L0 8.5L4.01066 6.73918L5.82618 2.84938L7.64171 6.73918L11.6524 8.5L7.64171 10.2608L5.82618 14.1506ZM5.82618 11.122L6.68444 9.3324L8.5297 8.5L6.68444 7.6676L5.82618 5.87795L4.96793 7.6676L3.12267 8.5L4.96793 9.3324L5.82618 11.122Z",
    fill: "white",
    fillOpacity: 0.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.3d0ae9bdc44b5b3d31f8dfd5582f72b4.svg";
export { ForwardRef as ReactComponent };